/*=========================================================================================
  File Name: module-amisconvert.js
  Description: AMIS Convert Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-amisconvert-state';
import mutations from './module-amisconvert-mutations';
import actions from './module-amisconvert-actions';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions
};
